import React from 'react';
import { WorkspaceHero } from '../components/WorkspaceHero';
import { NovaSection } from '../components/nova/NovaSection';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// Exploration variant of the home page. Identical to Home, but the hero is
// reimagined as an animated Slack/Teams workspace where colleagues @mention
// Giga and Giga replies with finished work — a place to explore the
// "chat box as a real workspace" direction.
export function WorkspaceHome() {
  return <>
      <WorkspaceHero data-id="element-6103" />
      <NovaSection data-id="element-6104" />
      <AudienceSwitch data-id="element-6105" />
      <LivesInSlack data-id="element-6106" />
      <ComputerUse data-id="element-6107" />
      <CapabilityGrid data-id="element-6108" />
      <NarrativeSection data-id="element-6109" />
      <WallOfLove data-id="element-6110" />
      <GettingStartedSteps data-id="element-6111" />
      <PricingSection data-id="element-6112" />
      <ClosingCTA data-id="element-6113" />
    </>;
}